

























import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { ZAKAZKA_CDB_STATUS } from '@/modules/servis/zakazka/constants';

import { Row } from '@/main/utils/table';

import { BaseSelect, selectName } from '#components/baseSelect';

import CreateDialog from './CreateDialog.vue';
import { NAME, PARTNER_MERGE } from '../constants';
import { apiProvider } from '../api';

export default BaseSelect.extend({
	name: selectName(NAME),
	components: {
		CreateDialog,
	},
	props: {
		labelKey: { type: String, default: 'ZAKAZNIK_ID' },
		labelKeyValue: { type: String, default: 'ZAKAZNIK_ID' },
		filter: { type: Object, default: () => {} },
		editPermission: { type: Boolean, default: true },
		cdbStatus: { type: Number },
		isViewable: { type: Boolean, default: false },
		customerAutocomplete: { type: Boolean, default: false },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'ZAKAZNIK_ID',
			apiProvider,
			labelCDB: '',
			dialog: {
				visible: false,
				zakaznikTyp: 1,
			},
		};
	},
	computed: {
		cdbIconStyle() : string {
			switch (this.cdbStatus) {
				case ZAKAZKA_CDB_STATUS.KOMUNIKACE:
					this.labelCDB = 'StatusCDBZakaznika-3';
					return 'el-icon-question gray info-button';
				case ZAKAZKA_CDB_STATUS.STATUS_ERROR:
					this.labelCDB = 'StatusCDBZakaznika-2';
					return 'el-icon-error red info-button';
				case ZAKAZKA_CDB_STATUS.CHYBA_VERZE:
					this.labelCDB = 'StatusCDBZakaznika-1';
					return 'el-icon-warning orange info-button';
				case ZAKAZKA_CDB_STATUS.OK:
					this.labelCDB = 'StatusCDBZakaznika0';
					return 'el-icon-success green info-button';
				case ZAKAZKA_CDB_STATUS.NOVA_VERZE:
					this.labelCDB = 'StatusCDBZakaznika1';
					return 'el-icon-warning orange info-button';
				case ZAKAZKA_CDB_STATUS.CHYBA_ZTOTOZNENI:
					this.labelCDB = 'StatusCDBZakaznika2';
					return 'el-icon-error red info-button';
				default:
					return '';
			}
		},
		existSlotPrepend() : boolean {
			return !!this.$slots.prepend;
		},
		showMergeBtn() : boolean {
			return (this.filter && (this.filter.Ozakazka && !this.filter.ZakaznikId && this.filter.ZakaznikKonId)) && !this.showCreateBtn;
		},
		showEditBtn() : boolean {
			return this.filter && (this.filter.Ozakazka || this.filter.Zakazka) && !!this.filter.ZakaznikId;
		},
		showCreateBtn() : boolean {
			return this.filter && this.filter.Create; // TODO: bude potreba jeste zkontrolovat pravo na vytvoreni zakaznika
		},
		showClearBtn() : boolean {
			return !(this.filter && this.filter.ZakaznikKonId);
		},
		customerSearchFilter() : object {
			return { Text: this.text };
		},
	},
	methods: {
		dbToBaseMapper(data: Record<string, any>) {
			return {
				value: data.ZAKAZNIK_ID,
				text: data.X_FIRM_PRIJM,
				splatnost: data.SPLATNOST_INL,
				platbaPzn: data.PLATBA_PZN,
				EMailAdresa: data.E_MAIL_ADRESA,
				TelmobNr: data.TELEFON_NR_LIST,
			};
		},
		async openEdit() {
			const pageParams = { id: this.filter.ZakaznikId };
			await openEdit(NAME, this.editPermission ? PageMode.EDIT : PageMode.VIEW, pageParams);
		},

		async openMerge() {
			// TP1/TODO: s iID to nejak nefunguje zjistit proc
			await openEdit(PARTNER_MERGE, PageMode.EDIT, { id: this.filter.ZakaznikId, kontaktId: this.filter.ZakaznikKonId });
		},
		additionalInfo({ cells }: Row, cellNames: Record<string, number>) : string {
			return cells[cellNames.X_FIRM_PRIJM];
		},
	},
});
